/**
 * tdesign v1.5.1
 * (c) 2023 tdesign
 * @license MIT
 */

import { _ as _slicedToArray } from '../../_chunks/dep-1ec078b3.mjs';
import { toRefs, computed, ref, watchEffect } from 'vue';
import useVModel from '../../hooks/useVModel.mjs';
import { i as isArray_1 } from '../../_chunks/dep-e9ff4ce8.mjs';
import { getDefaultFormat, isValidDate, initYearMonthTime, formatDate, formatTime } from '../../_common/js/date-picker/format.mjs';
import { extractTimeFormat } from '../../_common/js/date-picker/utils.mjs';
import '../../_chunks/dep-558fadc3.mjs';
import '../../_chunks/dep-398227bb.mjs';
import '../../_chunks/dep-34428f12.mjs';
import '../../_chunks/dep-84053b94.mjs';
import '../../_chunks/dep-2a69909d.mjs';
import '../../_chunks/dep-1c40d002.mjs';
import '../../_chunks/dep-8a0ff305.mjs';
import '../../_chunks/dep-c54c9f32.mjs';
import '../../_chunks/dep-c24f5c5d.mjs';
import '../../_chunks/dep-61150968.mjs';
import '../../_chunks/dep-b390ff23.mjs';
import '../../_chunks/dep-0927ceb7.mjs';
import '../../_common/js/log/index.mjs';
import '../../_common/js/log/log.mjs';
import '../../_chunks/dep-fa22eda7.mjs';
import '../../_chunks/dep-1f286011.mjs';
import '../../_chunks/dep-3ced59c9.mjs';
import '../../_chunks/dep-c59fea99.mjs';
import '../../_chunks/dep-3514a375.mjs';
import '../../_chunks/dep-8b3be089.mjs';
import '../../_chunks/dep-9d499243.mjs';
import '../../_chunks/dep-ac19a2b6.mjs';
import '../../_chunks/dep-07f3660d.mjs';
import '../../_chunks/dep-95049222.mjs';
import '../../_chunks/dep-45572c49.mjs';
import '../../_chunks/dep-e09a06d8.mjs';

var PARTIAL_MAP = {
  first: "start",
  second: "end"
};
function useRangeValue(props) {
  var _toRefs = toRefs(props),
    valueFromProps = _toRefs.value,
    modelValue = _toRefs.modelValue;
  var _useVModel = useVModel(valueFromProps, modelValue, props.defaultValue, props.onChange),
    _useVModel2 = _slicedToArray(_useVModel, 2),
    value = _useVModel2[0],
    onChange = _useVModel2[1];
  var formatRef = computed(function () {
    return getDefaultFormat({
      mode: props.mode,
      format: props.format,
      enableTimePicker: props.enableTimePicker
    });
  });
  if (props.enableTimePicker) {
    if (!extractTimeFormat(formatRef.value.format)) console.error("format: ".concat(formatRef.value.format, " \u4E0D\u89C4\u8303\uFF0C\u5305\u542B\u65F6\u95F4\u9009\u62E9\u5FC5\u987B\u8981\u6709\u65F6\u95F4\u683C\u5F0F\u5316 HH:mm:ss"));
  }
  if (!isArray_1(value.value)) {
    console.error("typeof value: ".concat(value.value, " must be Array!"));
  } else if (!isValidDate(value.value, formatRef.value.format)) {
    console.error("value: ".concat(value.value, " is invalid dateTime! Check whether the value is consistent with format: ").concat(formatRef.value.format));
  }
  var isFirstValueSelected = ref(false);
  var time = ref(initYearMonthTime({
    value: value.value,
    mode: props.mode,
    format: formatRef.value.format,
    timeFormat: formatRef.value.timeFormat
  }).time);
  var month = ref(initYearMonthTime({
    value: value.value,
    mode: props.mode,
    format: formatRef.value.format,
    enableTimePicker: props.enableTimePicker
  }).month);
  var year = ref(initYearMonthTime({
    value: value.value,
    mode: props.mode,
    format: formatRef.value.format
  }).year);
  var cacheValue = ref(formatDate(value.value, {
    format: formatRef.value.format
  }));
  watchEffect(function () {
    if (!value.value) {
      cacheValue.value = [];
      return;
    }
    if (!isValidDate(value.value, formatRef.value.format)) return;
    cacheValue.value = formatDate(value.value, {
      format: formatRef.value.format
    });
    time.value = formatTime(value.value, formatRef.value.format, formatRef.value.timeFormat, props.defaultTime);
  });
  return {
    year: year,
    month: month,
    value: value,
    time: time,
    isFirstValueSelected: isFirstValueSelected,
    cacheValue: cacheValue,
    onChange: onChange
  };
}

export { PARTIAL_MAP, useRangeValue as default };
//# sourceMappingURL=useRangeValue.mjs.map
